import Box from 'components/shared/Box'
import sleepChild from 'assets/images/maintenance/sleepChild.svg'
import Text from 'components/shared/Text'
import { Content, ImageWrapper } from './style'
import { FormattedMessage } from 'react-intl'
import Link from 'components/shared/Link'
import { HOME_LINK } from 'constants/links'
import { useMaintenanceContent } from './hooks'

interface MaintenanceProps {
    status?: number | string
}

export const Maintenance = ({ status }: MaintenanceProps) => {
    const { content } = useMaintenanceContent(status)

    return (
        <Content>
            <Box
                align={['flex-start', 'center']}
                justify="center"
                pl={[0, 30]}
                pr={[0, 30]}
                pt={[12, 8]}
            >
                <ImageWrapper>
                    <img src={sleepChild} alt="maintenance" />
                </ImageWrapper>

                <Text
                    variant="heading1"
                    mt={[32, 40]}
                    mb={16}
                    align={['left', 'center']}
                >
                    {content.title}
                </Text>
                <Box gap={24} justify="flex-start" pl={[0, 40]} pr={[0, 40]}>
                    <Text
                        variant="body"
                        color="grayscale_700"
                        align={['left', 'center']}
                        mb={[32, 40]}
                    >
                        {content.copy}
                    </Text>
                </Box>
                <Link
                    path={HOME_LINK}
                    variant="secondary"
                    iconColor="primary_500"
                    data-testid="page-maintenance-redirect-homepage"
                >
                    <FormattedMessage
                        id="global.btn.check_discounts"
                        defaultMessage="Sprawdź aktualne promocje"
                    />
                </Link>
            </Box>
        </Content>
    )
}
